import * as React from "react"

const Twitter = (props) => (
  <svg
    width={17}
    height={14}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.317 2.16a6.672 6.672 0 0 1-1.844.505A3.182 3.182 0 0 0 15.881.896a6.395 6.395 0 0 1-2.03.775 3.2 3.2 0 0 0-5.536 2.188c.001.254.023.498.075.73a9.058 9.058 0 0 1-6.596-3.347 3.205 3.205 0 0 0 .983 4.277 3.16 3.16 0 0 1-1.445-.394v.035a3.215 3.215 0 0 0 2.564 3.144c-.26.071-.545.105-.84.105a2.83 2.83 0 0 1-.605-.054 3.23 3.23 0 0 0 2.99 2.23 6.43 6.43 0 0 1-3.968 1.364c-.262 0-.514-.012-.766-.044a9.009 9.009 0 0 0 4.91 1.436c5.888 0 9.108-4.878 9.108-9.106 0-.142-.005-.278-.012-.414a6.383 6.383 0 0 0 1.604-1.661Z"
      fill={props.fill}
    />
  </svg>
)

export default Twitter;
